import { render, staticRenderFns } from "./Exame2.vue?vue&type=template&id=4f50878c&scoped=true"
import script from "./Exame2.vue?vue&type=script&lang=js"
export * from "./Exame2.vue?vue&type=script&lang=js"
import style0 from "./Exame2.vue?vue&type=style&index=0&id=4f50878c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f50878c",
  null
  
)

export default component.exports